var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"pipeline-background"},[_c('NEWPipelineComponent',{attrs:{"statuses":_vm.otherStatuses}}),_c('NEWPipelineComponent',{attrs:{"statuses":_vm.statusAll}})],1),_c('CommissioningOverviewTable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }